const Awards = () => {

  const variant = [
    'matchpaint'
  ]
  
  if (variant.includes(THEME)) {
    return `${AZURE_ICONS_URL}/${THEME}/awards.svg`
  }

  return `${AZURE_ICONS_URL}/awards.svg`
}

export default Awards